import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';

import Metadata from './Metadata';
import About from './About';

Modal.setAppElement('#root');

class Lightbox extends Component {
  static propTypes = {
    closeLightbox: PropTypes.func.isRequired,
    isOpen: PropTypes.bool.isRequired,
    content: PropTypes.string.isRequired,
    referrer: PropTypes.string,
    payload: PropTypes.shape({}),
  };

  static defaultProps = {
    referrer: '',
    payload: {},
  };

  render() {
    const { isOpen, closeLightbox, referrer, payload } = this.props;

    return (
      <Modal
        isOpen={isOpen}
        contentLabel={'temp...'}
        className="Lightbox"
        overlayClassName="LightboxOverlay"
        onRequestClose={closeLightbox}
      >
        <div className="lightbox__content">
          {referrer === 'dataLayer' ? (
            <Metadata {...{ ...payload, closeLightbox }} />
          ) : (
            <About {...{ closeLightbox }} />
          )}
        </div>
        <button className="lightbox__close" onClick={() => closeLightbox()}>
          {'×'}
        </button>
      </Modal>
    );
  }
}

export default Lightbox;



// WEBPACK FOOTER //
// ./src/components/Lightbox/Lightbox.jsx